import { OrderFulfillServices } from './order-fulfill.services';

export const getUserOrderFullFillmentData =
  (orderGuid) => (dispatch, getState) => {
    OrderFulfillServices.getUserService(orderGuid).then((response) => {
      if (response && response !== 404 && response.data !== '') {
      }
    });
  };
